import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

type Props = {
  jobTypeIdOptions: { label: string; value: string }[];
  onChange?: (value: string) => void;
};

export const JobTypeSelector: FC<Props> = ({ jobTypeIdOptions, onChange }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();
  const jobTypeId = watch("jobType");
  const errorMessage = errors.jobType?.message;
  const handleChange = (value: string) => {
    setValue("jobType", value, { shouldDirty: true });
    onChange?.(jobTypeIdOptions.find((option) => option.value.toString() === value)?.label || "");
  };

  return (
    <Presentation
      jobTypeIdOptions={jobTypeIdOptions}
      jobTypeId={jobTypeId}
      errorMessage={errorMessage}
      onChange={handleChange}
    />
  );
};
